import ProductDescriptionPreview from './ProductDescriptionPreview'

export default ProductDescriptionPreview
